import { ApplicationInsights  } from '@microsoft/applicationinsights-web';
import { EventAggregator } from 'aurelia-event-aggregator';
import { IdentityService } from 'services/identity-service';
import { LogManager } from 'aurelia-framework';
import { RouterEvent } from 'aurelia-router';
import { ServiceBase } from 'support/base_classes/service-base';
import { autoinject } from 'aurelia-framework';
import environment from '../environment';


@autoinject
export class TelemetryService extends ServiceBase {
  private appInsights: ApplicationInsights;
  private logger = LogManager.getLogger('TelemetryService');

  constructor(private identity: IdentityService, private eventAggregator: EventAggregator) {
    super();
  }

  protected async initializeService() {
    if (environment.telemetrySettings.enabled) {
      this.logger.info('Azure AppInsights telemetry enabled.');
      this.appInsights = new ApplicationInsights({
      config: {
        connectionString: environment.telemetrySettings.appInsightsConnectionString,
        disableFetchTracking: true,
        disableAjaxTracking: true,
        disableExceptionTracking: true,
      }
    });
    this.appInsights.loadAppInsights();
        
    // Setting email adress as user id was required by bp
    // https://digitalfoundations.visualstudio.com.mcas.ms/developerHub/_wiki/wikis/global_snp_trm.wiki/8839/Capturing-User-Email-Addresses-in-Application-Insights
    this.appInsights.clearAuthenticatedUserContext();
    this.appInsights.setAuthenticatedUserContext(this.identity.user.mail);
    this.appInsights.context.user.id = this.identity.user.mail;
       
    this.eventAggregator.subscribe(RouterEvent.Complete, event => this.appInsights.trackPageView());
    } else {
      this.logger.info('Azure AppInsights telemetry disabled.');
    }
  }
}
